// BrimLight/common/schemas/collections/generatedMedia.js
// --- CREATE NEW FILE ---
import { z } from "zod";

const GeneratedMediaSchema = z.object({
    _id: z.string().optional(),
    // No subscriptionId needed, as this is a global, shared library
     uuid: z.string().uuid().describe("A unique UUID for this media, used as the ID in the vector database."),   
    prompt: z.string().min(1).describe("The original generative prompt used to create the media."),
    type: z.enum(['sfx', 'music', 'ambient']).describe("The type of the audio media."),
    
    provider: z.string().describe("The AI provider used for generation, e.g., 'elevenlabs'."),
    providerId: z.string().optional().nullable().describe("The unique ID of the media on the provider's platform, if available."),
    
    durationSeconds: z.number().positive().describe("The duration of the audio in seconds."),
    relativePath: z.string().min(1).describe("The relative path to the media file for client access, e.g., 'global/sfx/filename.mp3'."),
    
    tags: z.array(z.string()).optional().default([]),
    
    createdAt: z.coerce.date().optional(),
});

export default GeneratedMediaSchema;